// Fallback components for Sentry error boundary

// Simple fallback error component for when Sentry is not available
export const SentryFallbackComponent = ({
  error,
  resetError,
}: {
  error: unknown
  resetError?: () => void
}) => {
  const errorMessage = error instanceof Error ? error.message : 'An unexpected error occurred'

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-6">
        <div className="flex items-center mb-4">
          <div className="flex-shrink-0">
            <svg className="h-8 w-8 text-yellow-500" fill="currentColor" viewBox="0 0 20 20">
              <path
                fillRule="evenodd"
                d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                clipRule="evenodd"
              />
            </svg>
          </div>
          <div className="ml-3">
            <h1 className="text-lg font-medium text-gray-900">Application Error</h1>
          </div>
        </div>
        <div className="mb-4">
          <p className="text-sm text-gray-600">
            Something went wrong. Please try refreshing the page.
          </p>
          <p className="text-xs text-gray-500 mt-2">Error: {errorMessage}</p>
        </div>
        <div className="space-y-2">
          {resetError && (
            <button
              onClick={resetError}
              className="w-full bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              Try Again
            </button>
          )}
          <button
            onClick={() => window.location.reload()}
            className="w-full bg-gray-600 text-white px-4 py-2 rounded-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
          >
            Refresh Page
          </button>
        </div>
      </div>
    </div>
  )
}
